import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, CalendarDays, Users, Search } from "lucide-react";

export const SearchBar = ({ onDark = true }) => {
  const [destination, setDestination] = useState("");
  const [date, setDate] = useState("");
  const [travelers, setTravelers] = useState("2");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    navigate(`/packages${destination ? `?search=${encodeURIComponent(destination)}` : ""}`);
  };

  const field = "flex items-center gap-3 px-5 py-3.5";
  const input = "bg-transparent w-full text-sm text-ink placeholder:text-ink/40 focus:outline-none";

  return (
    <motion.form onSubmit={submit}
      initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="bg-bone/95 backdrop-blur-xl rounded-2xl sm:rounded-full shadow-2xl p-2 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0 sm:divide-x sm:divide-ink/10 max-w-3xl"
      data-testid="hero-search-form">
      <label className={`${field} flex-1`}>
        <MapPin size={17} className="text-sun shrink-0" />
        <input value={destination} onChange={(e) => setDestination(e.target.value)} placeholder="Where to?" className={input} data-testid="search-destination-input" />
      </label>
      <label className={`${field} sm:w-44`}>
        <CalendarDays size={17} className="text-sun shrink-0" />
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className={`${input} text-ink/70`} data-testid="search-date-input" />
      </label>
      <label className={`${field} sm:w-40`}>
        <Users size={17} className="text-sun shrink-0" />
        <select value={travelers} onChange={(e) => setTravelers(e.target.value)} className={`${input} cursor-pointer`} data-testid="search-travelers-select">
          {[1, 2, 3, 4, 5, 6].map((n) => <option key={n} value={n}>{n} {n === 1 ? "traveler" : "travelers"}</option>)}
          <option value="7+">7+ travelers</option>
        </select>
      </label>
      <div className="p-1">
        <button type="submit" data-testid="search-submit-btn"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-sun text-bone font-semibold px-7 py-3 rounded-xl sm:rounded-full hover:bg-[#e85a28] hover:scale-[1.03] active:scale-95 transition-all">
          <Search size={16} /> Search
        </button>
      </div>
    </motion.form>
  );
};
